import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Collapse, Grid, Typography} from '@mui/material';

import {InfoIcon} from '../../../../../../assets/employee_satisfaction_bar';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

export const DreamEmployerExpandableInfo = () => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const {t} = useTranslation();

  const handleContainerClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Grid
      container
      onClick={handleContainerClick}
      sx={{
        backgroundColor: orangeColors[5],
        borderRadius: '16px',
        padding: '10px 20px',
        marginTop: 2,
        marginBottom: 2,
        cursor: 'pointer',
      }}
    >
      <InfoIcon fill={greenColors[700]} height={24} width={24} />
      <Typography marginLeft={2}>{t('companyCultureDashboard.employeeSatisfaction.modal.expandableTitle')}</Typography>
      <Collapse in={expanded}>
        <Typography variant='body2' gutterBottom>
          {t('companyCultureDashboard.employeeSatisfaction.modal.resultsDescription')}
        </Typography>
        <Typography variant='body2'>
          <strong>{t('companyCultureDashboard.employeeSatisfaction.modal.example')}</strong>
          {t('companyCultureDashboard.employeeSatisfaction.modal.exampleDescription')}
        </Typography>
      </Collapse>
    </Grid>
  );
};
